export var DataExportJobRunState;
(function (DataExportJobRunState) {
    DataExportJobRunState["Created"] = "CREATED";
    DataExportJobRunState["Failure"] = "FAILURE";
    DataExportJobRunState["Runnable"] = "RUNNABLE";
    DataExportJobRunState["Running"] = "RUNNING";
    DataExportJobRunState["Success"] = "SUCCESS";
    DataExportJobRunState["Invalid"] = "INVALID";
})(DataExportJobRunState || (DataExportJobRunState = {}));
//# sourceMappingURL=data-export.job-run-state.js.map